<template>
  <div>
    <header>
      <button :class="customHeader" class="flex items-center cursor-pointer" @click="toggle" type="button" :aria-expanded="active ? 'true' : 'false'">
        <div class="mr-2"
          >
          <base-button-icon 
            :focusable="false"
            :class="{'rotate-180':active}" 
            class="transform transition-transform duration-150" 
            type="primary-phantom" 
            name="chevrondown" 
            size="sm"
            :disabled="disabled"
            :titleIcon="active ? 'Contraer submenú' : 'Desplegar submenú'" 
            :ariaLabel="active ? 'Contraer submenú' : 'Desplegar submenú'" 
            />
        </div>
        <slot name="headerRight"/>
      </button>
    </header>
    <transition
      name="collapsible"
      @enter="startTransition"
      @after-enter="endTransition"
      @before-leave="startTransition"
      @after-leave="endTransition"
    >
      <section v-show="active" :class="overflowHidden ? 'overflow-hidden' : ''">
        <div :class="customContent">
            <slot name="content" />
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
import BaseButtonIcon from './BaseButtonIcon.vue'
export default {
  components: { BaseButtonIcon },
  name: 'base-collapsible',
  props: {
    customHeader: {
      type: String,
      default: ''
    },
    customContent: {
      type: String,
      default: ''
    },
    overflowHidden: {
      type: Boolean,
      default: true,
    }
  },
  data: function () {
    return {
      active: false,
      disabled: false,
    }
  },
  computed: {
    hasContent: function () {
      return this.$scopedSlots.headerLeft
    },
    isActive () {
      return this.active
    }
  },
  methods: {
    toggle () {
      if (!this.disabled) this.active = !this.active
    },
    startTransition (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTransition (el) {
      el.style.height = ''
    },
    openAndDisable () {
      this.active = true
      this.disabled = true
    },
    restoreDisable () {
      this.disabled = false
    }
  }
}
</script>

<style lang="scss" scoped>
.collapsible-enter-active,
.collapsible-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.collapsible-enter,
.collapsible-leave-to {
  height: 0 !important;
}
</style>
